import { SolarScreenMap } from '~/machines/solar-funnel/screen-map';
import { ScreenMapCopy } from '~/machines/utils/types';
import { BillingContext, BillingCopy } from '~/screens/billing';
import { CreateAccountContext, CreateAccountCopy } from '~/screens/create-account';
import { VnmTermsContext, VnmTermsCopy } from '~/screens/vnm-terms';
import { UTILITY_IDS } from '~/utils/constants';

const isVersantBHD = (id: number) => id === UTILITY_IDS['Versant - Bangor Hydro District'];
const versantUserDescription =
  'To unlock guaranteed savings of up to 15% on the solar credits applied to your power bill, create your Arcadia account so that we can match you with a community solar farm in your area.';
const versantBillingPayText =
  "We'll send you a bill for your contribution to the solar farm — an automatic payment that helps keep your solar farm running. You'll see your solar savings of up to 15% here.";
const versantTermsBenefit =
  'Guaranteed savings of up to 15% on the solar credits applied to your power bill';

export const copy: ScreenMapCopy<SolarScreenMap> = {
  user: {
    user: (context: CreateAccountContext): Partial<CreateAccountCopy> => {
      if (isVersantBHD(context.utility.id)) return { description: versantUserDescription };
      return {};
    },
    google: (context: CreateAccountContext): Partial<CreateAccountCopy> => {
      if (isVersantBHD(context.utility.id)) return { description: versantUserDescription };
      return {};
    },
  },
  billing: {
    payment: (context: BillingContext): Partial<BillingCopy> => {
      if (isVersantBHD(context.utility.id)) return { payArcadiaText: versantBillingPayText };
      return {};
    },
  },
  legal: {
    review: (context: VnmTermsContext): Partial<VnmTermsCopy> => {
      if (isVersantBHD(context.utility.id)) return { savingsBenefit: versantTermsBenefit };
      return {};
    },
  },
};
